import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginAuth } from './services/loginAuth.service';
import { AuthGuard } from './services/authguard.service';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), title: 'Futsal Oz' },
  { path: 'login', loadChildren: () => import('./auth/login/login.module').then(m => m.LoginModule), canActivate: [LoginAuth], title: 'Login' },
  { path: 'signup', loadChildren: () => import('./auth/signup/signup.module').then(m => m.SignupModule), canActivate: [LoginAuth], title: 'Signup' },
  { path: 'verify-otp', loadChildren: () => import('./auth/verify-otp/verify-otp.module').then(m => m.VerifyOtpModule), canActivate: [LoginAuth], title: 'Verify OTP' },
  { path: 'court-booking', loadChildren: () => import('./pages/court-booking/court-booking.module').then(m => m.CourtBookingModule), title: 'Court Booking' },
  { path: 'birthday-party', loadChildren: () => import('./pages/birthday-party/birthday-party.module').then(m => m.BirthdayPartyModule), title: 'Birthday Party' },
  { path: 'programs', loadComponent: () => import('./pages/all-programs/all-programs.component').then(m => m.AllProgramsComponent), title: 'Programs' },
  { path: 'programs/:id', loadComponent: () => import('./pages/brand-info/brand-info.component').then(m => m.BrandInfoComponent), title: 'Programs' },
  {
    path: 'create-team', loadComponent: () => import('./pages/create-team/create-team.component').then(m => m.CreateTeamComponent),
    title: 'Create Team',
    data: {
      playerTeam: 0,
    },
  },
  {
    path: 'create-player', loadComponent: () => import('./pages/create-team/create-team.component').then(m => m.CreateTeamComponent),
    title: 'Create Player',
    data: {
      playerTeam: 1,
    },
  },
  { path: 'my-bookings', loadComponent: () => import('./pages/my-bookings/my-bookings.component').then(m => m.MyBookingsComponent), title: 'My Bookings', canActivate: [AuthGuard] },
  { path: 'venues', loadComponent: () => import('./pages/venues/venues.component').then(m => m.VenuesComponent), title: 'Venues' },
  { path: 'rules', loadComponent: () => import('./pages/rules/rules.component').then(m => m.RulesComponent), title: 'Rules' },
  { path: 'junior', loadComponent: () => import('./pages/junior-championship/junior-championship.component').then(m => m.JuniorChampionshipComponent), title: 'junior' },
  { path: 'about', loadComponent: () => import('./pages/about-us/about-us.component').then(m => m.AboutUsComponent), title: 'About' },
  { path: 'franchise', loadComponent: () => import('./pages/franchise/franchise.component').then(m => m.FranchiseComponent), title: 'Franchise' },
  { path: 'contact', loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent), title: 'Contact' },
  { path: 'leagues', loadComponent: () => import('./pages/leagues/leagues.component').then(m => m.LeaguesComponent), title: 'Leagues' },
  { path: 'forgot-password', loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent), title: 'Forgot Password' },
  { path: 'events', loadComponent: () => import('./pages/book-events/book-events.component').then(m => m.BookEventsComponent), title: 'Events' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
